import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

const reportListStore = create(
  persist(
    immer((set) => ({
      reportList: [],
      allReportList: [],
      setReportList: (newList) =>
        set((state) => {
          state.reportList = newList;
        }),
      setAllReportList: (newList) =>
        set((state) => {
          state.allReportList = newList;
        }),
    })),
    {
      name: "reportList-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default reportListStore;
